import axiosInstance from "../../axiosInstance";

const BASE_URL = "/elearning/schedule";

export const getScheduleEvents = async (params = {}) => {
  const { branch_id, course_id, subject_id, from, to, venue } = params;
  const query = {};
  if (branch_id && branch_id !== "all") query.branch_id = branch_id;
  if (course_id && course_id !== "all") query.course_id = course_id;
  if (subject_id && subject_id !== "all") query.subject_id = subject_id;
  if (from) query.from = from;
  if (to) query.to = to;
  if (venue && venue !== "all") query.venue = venue;

  const res = await axiosInstance.get(`${BASE_URL}/events`, { params: query });
  return res.data;
};

export const getScheduleFilters = async () => {
  const res = await axiosInstance.get(`${BASE_URL}/filters`);
  return res.data;
};
